const GameState = {
	uninitialized: -1,
	playing: 0,
	done: 1,
	results: 2,
};

// TODO: Update font-size based on layout
document.setDefaultFontSize = function() {
	const container = document.getElementById('game-container');
	const containerWidth = container.clientWidth;
	let fontSize = Math.round(20 * containerWidth / 1055);
	document.documentElement.style.setProperty('--default-font-size', `${fontSize}px`);
}

document.setGameContainerSize = function() {
	const width = window.innerWidth;
	const height = window.innerHeight;
	const container = document.getElementById('game-ratio-container');

	if (height < (width * 2.8 / 4)) {
		container.style.width = `${Math.floor(height * 4 / 2.8)}px`;
	} else {
		container.style.width = `${width}px`;
	}
}

document.computeSizes = function() {
	document.setGameContainerSize();
	document.setDefaultFontSize();
}

document.Game = {
	state: GameState.uninitialized,
	currentQuestionIndex: 0,
	questions: [
		{ value: "cartilage", position: { x: 1.5, y: 60.1 } },
		{ value: "destruction", position: { x: 1.5, y: 34.5 } },
		{ value: "mise en mouvement", position: { x: 58, y: 18.5 } },
		{ value: "articulation", position: { x: 80.5, y: 75.5 } },
		{ value: "modérée", position: { x: 48, y: 78.6 } },
		{ value: "vive", position: { x: 70.5, y: 78.5 } },
		{ value: "chronique", position: { x: 48, y: 19 } },
		{ value: "aiguë", position: { x: 70.5, y: 18.3 } },
		{ value: "repos", position: { x: 91, y: 7.3 } },
		{ value: "imprévisible", position: { x: 36, y: 74.5 } },
		{ value: "pris en charge", position: { x: 24, y: 63.1 } },
		{ value: "irréversible", position: { x: 24, y: 7.8 } },
		{ value: "variable", position: { x: 12.2, y: 29.2 } },
	],
	render() {
		// Hide all game state
		const gameStates = document.getElementsByClassName('game-state');
		for (let i = 0; i < gameStates.length; i++) {
			if (!gameStates[i].classList.contains('hidden')) {
				gameStates[i].classList.add('hidden');
			}
		}
		// Call method to prepare everything then display the current state
		switch (this.state) {
			case GameState.playing:
				this.initPlayingState();
				document.getElementById('state-playing').classList.remove('hidden')
				break;
			case GameState.done:
				document.getElementById('state-done').classList.remove('hidden')
				break;
			case GameState.results:
				document.getElementById('state-results').classList.remove('hidden')
				break;
		}
	},
	initPlayingState() {
		let dropAreasHtml = "";
		// Placeholder for the first 3 elements
		let choicesAreaHtml = `<div></div><div></div><div></div>`;

		this.questions.forEach((question, index) => {
			dropAreasHtml += `<div class="drop-area" data-id="${index}" style="top: ${question.position.x}%; left: ${question.position.y}%;"></div>`;
			choicesAreaHtml += `<div class="choice" draggable="true" data-id="${index}">${question.value}</div>`;
		});

		const dropContainer = document.getElementById('drop-container');
		dropContainer.innerHTML = dropAreasHtml;

		const choicesContainer = document.getElementById('choices-container');
		choicesContainer.innerHTML = choicesAreaHtml;

		this.handleDragAndDrop();
	},
	handleDragAndDrop() {
		this.showingError = false;
		this.selectedItem = null;
		this.successCount = 0;

		const choicesElements = document.getElementsByClassName('choice');
		for (let i = 0; i < choicesElements.length; i++) {
			choicesElements[i].addEventListener("dragstart", (ev) => {
				if (this.showingError) {
					// Prevent drag while we're showing the previous response error message
					ev.preventDefault();
					return;
				}
				ev.dataTransfer.dropEffet = "move";
				this.selectedItem = choicesElements[i];
			});
		}

		const dropZones = document.getElementsByClassName("drop-area");
		for (let i = 0; i < dropZones.length; i++) {
			dropZones[i].addEventListener("dragover", (ev) => {
				ev.preventDefault();
				ev.dataTransfer.dropEffect = "move";
			});
			dropZones[i].addEventListener("drop", (ev) => {
				// Prevent drop on area already filled
				if (dropZones[i].innerHTML?.length) {
					return;
				}

				// Fill content
				dropZones[i].innerHTML = this.questions[+this.selectedItem.dataset.id].value;

				const success = dropZones[i].dataset.id === this.selectedItem.dataset.id;

				// If success - Apply success class, remove choice and move on
				if (success) {
					dropZones[i].classList.add('success');
					this.selectedItem.classList.add('done');
					this.selectedItem = null;
					this.successCount += 1;
					if (this.successCount === this.questions.length) {
						setTimeout(() => {
							this.showSuccessScreen();
						}, 1000);
					}
					return;
				}

				// If error, hide item temporarily, show tooltip then revert
				this.showingError = true; // To stop the game while showing error
				this.selectedItem.classList.add('done'); // To hide it temporarily

				// Show tooltip
				const errorDiv = document.createElement('div');
				errorDiv.innerHTML = "<strong>Oups !</strong> Ce n'est pas ici.";
				errorDiv.setAttribute("id", "error-message");
				if (this.questions[i].position.y > 50) {
					errorDiv.classList.add('left');
				}
				dropZones[i].appendChild(errorDiv);

				setTimeout(() => {
					this.showingError = false;
					dropZones[i].innerHTML = '';
					this.selectedItem.classList.remove('done');
					this.selectedItem = null;
				}, 2000);
			});
		}
	},
	restart() {
		this.state = GameState.playing;
		this.render();
	},
	showSuccessScreen() {
		this.state = GameState.done;
		this.render();
	},
	seeResults() {
		this.state = GameState.results;
		this.render();
	}
}

document.computeSizes();
document.Game.restart();

addEventListener('resize', document.computeSizes);
